<template>
    <div class="af" >
        <el-form class="table" v-loading="loading" :model="formData" :rules="formRules" ref="formRef"  size="mini">
            <el-button style="padding:6px 0 0 8px" type="text" @click.stop="lookreport">{{$t('purchaseOrder_view_execution')}}</el-button>
            <div class="flex borb">
                <el-form-item class="form-title num flex" prop="vc_no" label="No:" >
                    <span  style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.vc_no?formData.vc_no:'000000'}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="isRelPurchase" :label="$t('purchaseOrder_is_it_associated_with_procurement')" >
                    <template >
                        <el-radio-group v-model="formData.isRelPurchase" @change="isRelPurchaseChange" :disabled="isedit">
                            <el-radio :label="1">{{$t('form_correct')}}</el-radio>
                            <el-radio :label="0">{{$t('form_deny')}}</el-radio>
                        </el-radio-group>
                    </template>
                </el-form-item>
                <el-form-item class="form-title" v-if="formData.isRelPurchase==1" prop="relRecvCompany" :label="$t('purchaseOrder_associated_receiving_company')" :required="formData.isRelPurchase==1">
                    <el-select v-if="!isedit" v-model="formData.relRecvCompany" @change="choosegk($event,'glsh')" filterable clearable  size="mini" style="margin-right: 9px;width: 150px">
                        <el-option v-for="item in jtgsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <span v-else  style="display: inline-block;width: 100%">{{formData.relRecvName}}</span>

                </el-form-item>
             </div>
            <div class="flex borb marT10" v-if="i_id!=0&&i_issq==1" >
                <el-form-item v-if="i_id!=0&&i_issq==1" class="form-title flex" prop="dt_expiretime" :label="$t('purchaseOrder_expiration_time')" >
                    <span  style="display: inline-block;width: 100%">{{formData.dt_expiretime}}</span>
                </el-form-item>
                <el-form-item v-if="i_id!=0&&i_issq==1" class="form-title flex" prop="gsname" :label="$t('purchaseOrder_count_down')" >
                    <count-down v-if="endTimestamp" :end-time="endTimestamp" @end="handleCountdownEnd"></count-down>
                    <span v-else  style="display: inline-block;width: 100%">{{$t('purchaseOrder_expired')}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="vc_type" :label="$t('purchaseOrder_order_type')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_type}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_gysname" :label="$t('purchaseOrder_supplier')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_gysname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_fno" :label="$t('purchaseOrder_order_contract_number')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_fno}}</span>
                </el-form-item>
            </div>
            <div class="flex borb" v-if="formData.isRelPurchase==1&&formData.i_gsid!==formData.relRecvCompany">
                <el-form-item class="form-title flex" prop="vc_directPurchase_deptname" :label="$t('purchaseOrder_direct_procurement_department')" >
                    <el-select class="nodata wid100" v-model="formData.vc_directPurchase_deptname" :placeholder="$t('form_please_select')" @change="choosegk($event,'bm')" filterable required clearable :disabled="isedit">
                        <el-option
                                v-for="item in bmData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_directPurchase_uname" :label="$t('purchaseOrder_direct_procurement_business')" >
                    <el-select class="nodata wid100" v-model="formData.vc_directPurchase_uname" :placeholder="$t('form_please_select')" @change="choosegk($event,'ry')" filterable required clearable :disabled="isedit">
                        <el-option
                                v-for="item in ryData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="vc_company" :label="$t('purchaseOrder_ordering_company')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_company}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_bmname" :label="$t('purchaseOrder_order_department')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_bmname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_kduname" :label="$t('form_drawer')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_kduname}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="vc_paytype" :label="$t('saleOrder_payment_type')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_paytype}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_payway" :label="$t('saleOrder_payment_method')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_payway}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="i_kpnumtype" :label="$t('purchaseOrder_invoice_quantity')" >
                    <template class="wid100">
                        <el-radio v-model="i_kpnumtype" label="0" :disabled="isedit">{{$t('purchaseOrder_order_quantity')}}</el-radio>
                        <el-radio v-model="i_kpnumtype" label="1" :disabled="isedit">{{$t('purchaseOrder_pound_order_quantity')}}</el-radio>
                    </template>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="gsname" :label="$t('form_currency')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_bzname+" "+"("+$t('purchaseOrder_exchange_rate') +formData.f_rate+")"}}</span>
                </el-form-item>
                <el-form-item :class="[i_issq=='1'?'form-title':'wid66' , 'flex']" prop="vc_paynote" :label="$t('purchaseOrder_payment_instructions')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_paynote}}</span>
                </el-form-item>
                <el-form-item v-if="i_issq=='1'" class=" flex" prop="dt_yjdhtime" :label="$t('purchaseOrder_expected_delivery_time')" >
                    <el-date-picker
                            size="mini"
                            v-model="formData.dt_yjdhtime"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            class="flex"
                            :placeholder="$t('purchaseOrder_expected_delivery_time')"
                            :disabled="isedit">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title" prop="i_isdirexport" :label="$t('purchaseOrder_is_it_targeted_procurement')" >{{formData.i_isdirexport?$t('form_correct'):$t('form_deny')}}

                </el-form-item>
                <el-form-item class="form-title" prop="i_dirgsid" :label="$t('purchaseOrder_targeted_affiliated_companies')" v-if="formData.i_isdirexport">{{formData.vc_dirgsname}}
                </el-form-item>

<!--                <el-form-item class="form-title" prop="i_xtype" :label="$t('purchaseOrder_nature_of_goods')" >{{formData.i_xtype==0?$t('form_domestic_sales'):$t('form_export')}}-->

                <el-form-item class="form-title" prop="i_xtype" :label="$t('purchaseOrder_nature_of_goods')" >
                    <!--{{formData.i_xtype==0?'内销':'外销'}}-->
                    <template class="wid100">
                        <el-radio v-model="formData.i_xtype" :label="0" :disabled="isedit">{{($t('form_domestic_sales'))}}</el-radio>
                        <el-radio v-model="formData.i_xtype" :label="1" :disabled="isedit">{{($t('form_export'))}}</el-radio>
                    </template>

                </el-form-item>
            </div>
            <!--进口-->
            <div v-if="i_isforeign==1" class="borb">
                <div class="flex">
                    <el-form-item class="form-title flex" prop="vc_startport" :label="$t('purchaseOrder_starting_port')" >
                        <el-select class="nodata wid100" v-model="formData.vc_startport" :placeholder="$t('form_please_select')" @change="choosegk($event,'qs')" filterable required clearable :disabled="isedit">
                            <el-option
                                    v-for="item in gkData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title flex" prop="vc_endport" :label="$t('purchaseOrder_port_of_destination')" >
                        <el-select class="nodata wid100" v-model="formData.vc_endport" :placeholder="$t('form_please_select')" @change="choosegk($event,'md')"  filterable required clearable :disabled="isedit">
                            <el-option
                                    v-for="itembm in gkData"
                                    :key="itembm.i_id"
                                    :label="itembm.vc_name"
                                    :value="itembm.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="flex">
                    <el-form-item class="form-title flex" prop="vc_kzkhname" :label="$t('purchaseOrder_issuer')" >
                        <el-select class="nodata wid100"  v-model="formData.vc_kzkhname" :placeholder="$t('form_please_select')" @change="choosekz" filterable required clearable :disabled="isedit">
                            <el-option
                                    v-for="one in kzData"
                                    :key="one.i_id"
                                    :label="one.vc_name"
                                    :value="one.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title flex" prop="f_bzj" :label="$t('purchaseOrder_margin_ratio')" >
                        <span  style="display: inline-block;width: 100%">{{formData.f_bzj}}</span>
                    </el-form-item>
                    <el-form-item class="form-title flex" prop="dt_kztime" :label="$t('purchaseOrder_issuing_date')" >
                        <el-date-picker
                                v-if="formData.can_add_lc"
                                class="wid100"
                                size="mini"
                                v-model="formData.dt_kztime"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :placeholder="$t('purchaseOrder_issuing_date')"
                                :disabled="isedit"
                                :picker-options="pickerOptions_kz">
                        </el-date-picker>
                        <span v-else style="display: inline-block;width: 100%">{{formData.dt_kztime}}</span>
                    </el-form-item>
                </div>
                <div class="flex">
                    <el-form-item class="form-title flex" prop="i_lcday" :label="$t('purchaseOrder_lct_days')" >
                        <el-input v-if="formData.can_add_lc" class="nodata wid100"  v-model="formData.i_lcday" :disabled="isedit"></el-input>
                        <span v-else  style="display: inline-block;width: 100%">{{formData.i_lcday}}</span>
                    </el-form-item>
                    <el-form-item class="form-title flex" prop="vc_xyno" :label="$t('purchaseOrder_letter_of_credit_number')" >
                        <el-input v-if="formData.can_add_lc" class="nodata wid100"  v-model="formData.vc_xyno" :disabled="isedit"></el-input>
                        <span v-else style="display: inline-block;width: 100%">{{formData.vc_xyno}}</span>
                    </el-form-item>
                </div>
                <div class="flex ">
                    <el-form-item class="form-title flex" prop="vc_tdcode" :label="$t('saleOrder_b/l_no')" >
                        <el-input class="nodata wid100"  v-model="formData.vc_tdcode" :disabled="isedit"></el-input>
                    </el-form-item>
                    <el-form-item class="form-title flex" prop="dt_tdtime" :label="$t('purchaseOrder_bill_of_lading_date')" >
                        <el-date-picker
                                class="wid100"
                                size="mini"
                                v-model="formData.dt_tdtime"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :placeholder="$t('purchaseOrder_bill_of_lading_date')"
                                :disabled="isedit">
                        </el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <!--<div class="flex borb">
                <el-form-item class="form-title" prop="gsname" :label="$t('saleOrder_delivery_method')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_sendway}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="gsname" label="运费承担方" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_yffd}}</span>
                </el-form-item>
            </div>-->
            <div class="flex moren mar3">
                <el-form-item class="form-title flex guding" prop="gsname" :label="$t('purchaseOrder_default_application_for_storage')" >
                    <template class="wid100">
                        <el-radio-group v-model="i_issq" @change="changehy" :disabled="ismoren">
                            <el-radio label="1">{{$t('form_correct')}}</el-radio>
                            <el-radio label="0">{{$t('form_deny')}}</el-radio>
                        </el-radio-group>
                       <!-- <el-radio v-model="i_issq" label="1" :disabled="isedit">是</el-radio>
                        <el-radio v-model="i_issq" label="0" :disabled="isedit">{{$t('form_deny')}}</el-radio>-->
                        <!--<div v-if="i_id==0&&i_issq=='1'&&formData.vc_sendway=='送货'" class="point">{{'此为单次车入库申请'}}</div>-->
                        <div v-if="i_id==0&&i_issq=='1'" class="point fontW500">
                            <!--<span class="point">申请 </span>
                            <span class="point fontW700">{{sqEffectivedays}}</span>
                            <span class="point"> 天有效期,请在有效期内执行完</span>-->
                            {{$t('purchaseOrder_apply_for_validity_period_please_complete_within_the_validity_period',{num:sqEffectivedays})}}
                        </div>
                    </template>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_sendway" :label="$t('saleOrder_delivery_method')" >
                    <span v-if="i_isframe==0"  style="display: inline-block;width: 100%">{{formData.vc_sendwayshow}}</span>
<!--                    <span v-if="i_isframe==0"  style="display: inline-block;width: 100%">{{sendway.find(s=>formData.vc_sendway==s.vc_sendway).vc_sendwayshow}}</span>-->
                    <el-select v-else  class="nodata wid100" v-model="formData.i_sendway" :placeholder="$t('form_please_select')" @change="choosesendway" filterable required clearable :disabled="isedit">
                        <el-option
                                v-for="one in sendway"
                                :key="one.i_sendway"
                                :label="one.vc_sendwayshow"
                                :value="one.i_sendway">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_yffd" :label="$t('purchaseOrder_freight_bearer')" >
                    <span v-if="i_isframe==0" style="display: inline-block;width: 100%">{{formData.vc_yffd}}</span>
                    <el-radio-group v-else v-model="formData.vc_yffd" :disabled="isedit">
                        <el-radio label="需方">{{$t('purchaseOrder_buyer')}}</el-radio>
                        <el-radio label="供方">{{$t('purchaseOrder_supplier')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <!--是显示-->
            <div v-if="i_issq=='1'">
                <div class="flex">
                    <el-form-item class="form-title flex" prop="vc_ckname" :label="$t('purchaseOrder_warehousing_warehouse')" >
                        <el-select class="nodata wid100" v-model="formData.vc_ckname" :placeholder="$t('form_please_select')" @change="chooseck" filterable required clearable :disabled="isedit">
                            <el-option
                                    v-for="one in ckData"
                                    :key="one.i_id"
                                    :label="one.vc_name"
                                    :value="one.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="wid66 flex" prop="gsname" :label="$t('purchaseOrder_warehouse_address')" >
                        <el-select class="nodata wid100" v-model="sendaddall" :placeholder="$t('form_please_select')" @change="chooseckaddr" filterable required clearable :disabled="isedit">
                            <el-option
                                    v-for="one in ckaddrData"
                                    :key="one.i_id"
                                    :label="one.vc_all"
                                    :value="one.i_id">
                            </el-option>
                        </el-select>
                        <!--<el-select class="nodata wid100" v-model="formData.vc_sendadd+'/'+formData.vc_sendadd_lxr+'/'+formData.vc_sendadd_lxr_tel" placeholder="请选择" @change="chooseckaddr" filterable required clearable :disabled="isedit">
                            <el-option
                                    v-for="one in ckaddrData"
                                    :key="one.i_id"
                                    :label="one.vc_sendaddr+'/'+one.vc_lxr+'/'+one.vc_tel"
                                    :value="one.i_id">
                            </el-option>
                        </el-select>-->
                    </el-form-item>
                </div>
                <el-form-item class="width100_f flex" prop="gsname" :label="$t('purchaseOrder_supplier_address')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_start_add?formData.vc_start_add+'/'+formData.vc_start_lxr+'/'+formData.vc_start_lxr_tel:""}}</span>
                </el-form-item>

                <div class="flex mar3">
                    <!--化验-->
                    <!--<el-form-item class="form-title" prop="gsname" label="是否需要化验" >
                        <template >
                            <el-radio-group v-model="i_ischeck" :disabled="isedit">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">{{$t('form_deny')}}</el-radio>
                            </el-radio-group>
                        </template>
                    </el-form-item>-->
                    <el-form-item class="form-title" prop="istran" :label="$t('purchaseOrder_whether_to_arrange_transportation')" >
                        <template >
                            <el-radio-group v-model="formData.istran" @change="chooseys" :disabled="disys">
                                <el-radio :label="1">{{$t('form_correct')}}</el-radio>
                                <el-radio :label="0">{{$t('form_deny')}}</el-radio>
                            </el-radio-group>
                        </template>
                    </el-form-item>

                    <el-form-item v-if="formData.istran==1" class="form-title" prop="vc_wluname" :label="$t('purchaseOrder_logistics_specialist')" >
                        <el-select  v-model="formData.vc_wluname" :placeholder="$t('form_please_select')" @change="chooseper" filterable required clearable :disabled="isedit">
                            <el-option
                                    v-for="one in ysper"
                                    :key="one.i_id"
                                    :label="one.vc_name"
                                    :value="one.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="flex mar3" v-if="formData.isRelPurchase==0">
                <el-form-item class="form-title" prop="i_source"  :label="$t('purchaseOrder_source_of_goods')" >
                    <template >
                        <el-radio-group v-model="formData.i_source" @change="goodssourceChange" >
                            <el-radio :label="1">{{$t('purchaseOrder_contract_processing')}}</el-radio>
                            <el-radio :label="0">{{$t('purchaseOrder_procurement')}}</el-radio>
                        </el-radio-group>
                    </template>
                </el-form-item>
                <el-form-item v-if="formData.i_source==1" class="form-title" prop="vc_consignorname" :label="$t('purchaseOrder_client')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_consignorname}}</span>
                </el-form-item>

            </div>
            <div style="margin:3px 0 10px 0">
                <el-table class="table"
                          border
                          ref="multipleTable"
                          :data="pzlist"
                          height="255"
                          size="mini"
                          :row-class-name="tableRowClassName"
                          tooltip-effect="dark">
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="center"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="vc_no"
                            :label="$t('form_order_number')"
                            width="70"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <!--<el-table-column
                            align="center"
                            prop="vc_pcno"
                            label="入库批次号"
                            width="130"
                            v-if="i_issq=='1'">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="pzlist.vc_pcno" >
                                <el-input  :disabled="isedit" :controls="false"  class="changeinput" size="mini" v-model="scope.row.vc_pcno" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>-->
                    <el-table-column
                            align="center"
                            prop="f_num"
                            :label="$t('purchaseOrder_number_of_bills_issued')"
                            width="130">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="pzlist.f_num" >
                                <el-input-number  :disabled="isedit" :controls="false"  :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_num" @change="numinput($event,scope.row,scope.$index)"></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="f_sl"
                            :label="$t('form_tax_rate')"
                            width="130">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="pzlist.f_sl" >
                                <el-input-number :disabled="isedit" :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_sl" ></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            width="50"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="f_price"
                            :label="$t('purchaseOrder_order_unit_price')"
                            width="130"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="pzlist.f_price" >
                                <div v-if="i_isframe==0" style="font-size: 12px">{{scope.row.f_price}}</div>
                                <el-input-number v-else :disabled="isedit" :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_price" ></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="f_je"
                            :label="$t('purchaseOrder_order_amount')"
                            width="100"
                            show-overflow-tooltip>
                    </el-table-column>
                    <template v-if="formData.isRelPurchase==1">
                        <el-table-column
                                align="center"
                                prop="relPrice"
                                :label="$t('purchaseOrder_unit_price_of_receiving_company')"
                                width="100"
                                show-overflow-tooltip>
                        </el-table-column>

                    </template>
                    <template v-else>
                        <el-table-column
                                align="center"
                                prop="f_open_price"
                                :label="$t('purchaseOrder_unit_price_for_unveiling_the_plaque')"
                                width="100"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="f_open_price_je"
                                :label="$t('purchaseOrder_unveiling_amount')"
                                width="100"
                                show-overflow-tooltip>
                        </el-table-column>
                    </template>

                    <el-table-column
                            align="center"
                            prop="i_ischeck"
                            :label="$t('form_do_you_want_to_test_it')"
                            width="70"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>{{scope.row.i_ischeck==1?$t('form_correct'):$t('form_deny')}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="i_ismustcheck"
                            :label="$t('purchaseOrder_is_it_necessary_to_inspect_unloading')"
                            width="70"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>{{scope.row.i_ismustcheck==1?$t('form_correct'):$t('form_deny')}}</div>
                        </template>
                    </el-table-column>
                    <!--<el-table-column
                            align="center"
                            prop="f_yfee_yj"
                            :label="$t('saleOrder_estimated_shipping_cost')"
                            width="150"
                            v-if="formData.istran==1&&i_issq=='1'">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="pzlist.f_yfee_yj" >
                                <el-input-number :disabled="isedit" :controls="false" :min="0" :precision="5" class="changeinput" size="mini" v-model="scope.row.f_yfee_yj" ></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>-->
                    <el-table-column  align="center"  width="50"  v-if="!isedit">
                        <template slot="header" slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    placement="bottom-end"
                                    width="1000"
                                    trigger="manual"
                                    v-model="visible">
                                <template>
                                    <product-details v-if="visible==true" :productDetails="productDetails" @closePop="closePop" @transValue="transValue"></product-details>
                                </template>
                                <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                            </el-popover>
                        </template>
                        <template  slot-scope="scope">
                            <div class="iconminus">
                                <span class="minus" v-show="!isedit" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                            </div>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <el-form-item class="flex wid100_bz" prop="vc_note" :label="$t('form_notes')" >
                <el-input class="wid100"  v-model="formData.vc_reviewnote">
                </el-input>
            </el-form-item>
            <div class="flex">
                <el-form-item class="flex wid50" prop="vc_lruname" :label="$t('form_creator')" >
                    <el-input class="wid100"  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="flex wid50" prop="date" :label="$t('form_date')" >
                    <el-input  class="wid100" v-model="formData.dt_createtime" disabled>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" v-if="!formData.vc_contractcode_sn" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveForm" :disabled="disabled" class="btn" size="small">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
            <el-button type="danger" @click="terminate" :disabled="i_id==0||formData.i_over==1" size="small">{{$t('button_terminate')}}</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp,sqEffectivedays} from "@/utils/baseUrl";
    import ProductDetails from "./ProductDetails";
    import countDown from "./countDown";
    import {mapActions} from "vuex";
    export default {
        name: "addOrder",
        components: {
            ProductDetails,
            countDown,
        },
        props:{
            application:{
                type:Object,
                required:true,
            }
        },
        data(){
            var validaterelRecvCompany = (rule, value, callback) => {
                if (value === ''&&this.formData.isRelPurchase==1) {
                    callback(new Error(this.$t('purchaseOrder_please_select_the_associated_receiving_company')));
                } else {
                    callback();
                }
            };
            return{
                endTimestamp:null,//时间戳
                sqEffectivedays:null,//申请有效天数
                istran:0,
                ysper:[],
                disys:true,
                i_isframe:0,
                sendway: [
                    {
                        i_sendway: 0,
                        vc_sendway: "送货",
                        vc_sendwayshow: this.$t('form_delivery')
                    },
                    {
                        i_sendway: 1,
                        vc_sendway: "自提（上力费我司付）",
                        vc_sendwayshow: this.$t('form_self_pickup_our_company_will_pay_the_upper_power_fee')
                    },
                    {
                        i_sendway: 2,
                        vc_sendway: "自提（上力费供应商付）",
                        vc_sendwayshow: this.$t('form_self_pickup_paid_by_the_supplier')
                    },
                    // {
                    //     i_sendway: 0,
                    //     vc_sendway: this.$t('form_delivery')
                    // },
                    // {
                    //     i_sendway: 1,
                    //     vc_sendway: this.$t('purchaseOrder_self_pickup_our_company_will_pay_the_upper_power_fee')
                    // },
                    // {
                    //     i_sendway: 2,
                    //     vc_sendway:this.$t('purchaseOrder_self_pickup_paid_by_the_supplier')
                    // },
                ],
                i_ischeck:0,
                i_isforeign:0,
                loading:false,
                i_id:0,
                //yanzheng
                busType: "",
                dt_createtime:"",
                uid:0,
                table: "",
                validateCode: "",
                validateKeynames: "",

                ckaddrData:[],
                i_ckid:0,
                ckData:[],
                i_htid:0,
                gkData:[],
                kzData:[],
                isbtn:false,
                isedit:false,
                ismoren:false,
                i_type:104,
                startaddall:"",
                sendaddall:"",
                formData:{
                    istran:0,
                    isRelPurchase:0,
                    relRecvCompany:'',
                    i_directPurchase_deptid:0,
                    vc_directPurchase_deptname:'',
                    i_directPurchase_uid:0,
                    vc_directPurchase_uname:'',
                    i_over:1,
                    i_source:0,
                    i_consignorid:0,
                    vc_consignorname:'',
                },
                bmData:[],
                ryData:[],
                pzlist:[],
                i_issq:'0',
                i_kpnumtype:"0",
                /******************************/
                gsname:"",
                bmname:"",
                sqName:"",
                ckname:"",
                groupid:0,
                formRules:{
                    //f_num:[{required:true,message:"请填写出库量",trigger:"blur"},],
                    relRecvCompany:[{validator:validaterelRecvCompany,trigger: 'blur'}],

                },
                companyName:[],
                groupName:[],
                personName:[],
                warehouseName:[],
                tableData:[],
                f_num:"",
                visible:false,
                productDetails:{},
                vc_note:"",
                date:"",
                disabled:false,

                edit:false,
                data:{},
                i_pid:0,
                state:0,
                qgsname:"",
                qckname:"",
                gsid:0,
                gid:0,
                i_rwid:0,
                ckid:0,
                squid:0,
                index:0,
                pageSize:1,
                baseerp:"",
                form:{},
                mid:0,
                dxglgsList:[],
                jtgsList:[],
                jtgs_search:'',
                relRecvCompany:'',
                // 日期面板禁用配置
                pickerOptions_kz: {
                    disabledDate: (time) => {
                        // 如果 mounted 还没获取到 dt_time，则暂不禁用
                        if (!this.formData.dt_time) {
                            return false;
                        }

                        // 将合同时间转为 Date，并归零时分秒（只对比年月日）
                        const dtTime = new Date(this.formData.dt_time);
                        dtTime.setHours(0, 0, 0, 0);

                        // 禁用早于合同时间的日期
                        return time.getTime() < dtTime.getTime();
                    }
                }
            }
        },
        watch: {
           /* application: {
                handler() {
                    if (this.application) {
                        console.log("this.application",this.application);
                        this.pageSize=this.application.page_size;
                        this.i_id = this.application.i_id;
                        this.mid = this.application.i_mid;
                        this.i_pid = this.application.i_pid;
                        this.i_type = this.application.i_type;
                        this.formData={
                            gsname:this.application.value.vc_gsname,
                            bmname:this.application.value.vc_cjname,
                            sqName: sessionStorage.getItem("lruname"),
                            ckname:this.application.value.vc_ckname,
                            num:this.i_pid,
                            // vc_note:this.application.vc_note,
                            vc_lruname: sessionStorage.getItem("lruname"),
                            date:this.application.value.dt_createtime,
                        };
                        this.gsid=this.application.value.i_gsid;
                        this.gid=this.application.value.i_cjid;
                        this.ckid=this.application.value.i_ckid;
                        if ((this.i_pid ?? '' !== '') && this.i_pid != 0) {
                            this.edit = true;
                            this.getPickingListSc();
                        } else if (this.i_pid == 0) {
                            this.productDetails.gsid=this.application.value.i_gsid;
                            this.productDetails.i_mid=this.mid;
                            this.productDetails.i_type=this.i_type;
                            this.productDetails.ckid=this.application.value.i_ckid;
                            this.productDetails.gsid_out=this.application.value.i_gsid_out;
                            this.productDetails.i_pzid=this.application.value.i_pzid;
                            this.productDetails.selected=[];
                            this.edit = false;
                            /!*this.getCompanyList();
                            this.getGroupList();
                            this.getWarehouseList();*!/
                            this.getDateYYYYMMddHHMMSS();
                        }
                        // console.log(this.application, "this.application");
                    }
                },
                immediate: true,
                deep: true
            }*/
        },
        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            this.sqEffectivedays=sqEffectivedays;
            //console.log('this.sqEffectivedays',this.sqEffectivedays)
            this.getLssuerList();
            this.getPortList();
            this.getWarehouseList();
            this.getCompanyList();
            this.getCompanyList(1);//关联公司
            //console.log(this.application,"-----------")
            let title = this.application.titleID;
            if(title=="addNew"){
                let data=this.deepClone(this.application.data);
                // console.log("新增数据",data);
                this.i_htid=data.htid;
                this.i_type=data.i_type;
                this.i_isforeign=data.i_isforeign;
                //进口合同可以编辑是否运输
                this.disys=data.i_isforeign==1?false:true;
                //this.i_issq=data.i_isforeign==1?'0':'1';
                this.i_isframe=data.i_isframe;
                //this.startaddall=data.vc_start_add+'/'+data.vc_start_lxr+'/'+data.vc_start_lxr_tel;
                this.sendaddall=data.vc_sendadd+'/'+data.vc_sendadd_lxr+'/'+data.vc_sendadd_lxr_tel;
                this.formData=data;
                this.formData.vc_lruname=sessionStorage.getItem("lruname");
                this.formData.vc_sendwayshow=this.sendway.find(s=>this.formData.vc_sendway==s.vc_sendway).vc_sendwayshow;
                this.$set(this.formData, 'i_source', 0);
                /*if(this.formData.vc_sendway!='送货'){
                   this.ismoren=true;
                }*/
                this.istran=data.istran;
                if(this.formData.istran==1){
                    this.getTranUserlist();
                }
                this.getDateYYYYMMddHHMMSS();
                this.getAddressList();
            }else{
                //console.log("编辑id",this.i_id,this.application);
                this.i_id=this.application.i_id;
                this.i_type=this.application.i_type;
                this.i_isforeign=this.application.i_isforeign;
                this.isedit=true;
                this.isbtn=true;
                this.ismoren=true;
                this.getPurchaseOrderDetail();

            }

        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            //报表
            lookreport() {
                this.$emit('lookreport',this.i_id);
            },
            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            async getPersonList(){
                let param={
                    i_groupid:this.formData.i_directPurchase_deptid,
                    isAll:0,
                    isNoRight:0,
                };
                let res=await API.getPersonList(param);
                if(res.code==1){
                    this.ryData=res.data;
                    if(res.data.length==1){
                        this.formData.i_directPurchase_uid=res.data[0].i_id;
                        this.formData.vc_directPurchase_uname=res.data[0].vc_name;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getGroupList(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.formData.relRecvCompany,
                    //isAll:1
                    isNoRight:0,
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.bmData=res.data;
                    if(res.data.length==1){
                        this.formData.i_directPurchase_deptid=res.data[0].i_id;
                        this.formData.vc_directPurchase_deptname=res.data[0].vc_name;
                        this.getPersonList(this.formData.i_directPurchase_deptid)
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            goodssourceChange(e){
                // console.log("goodssourceChangee",e)
                this.formData.i_source=e;
                if(e==1){
                    this.formData.i_consignorid=this.formData.i_gykhid;
                    this.formData.vc_consignorname=this.formData.vc_gysname;
                }else{
                    this.formData.i_consignorid=0;
                    this.formData.vc_consignorname='';
                }
                this.$forceUpdate();
            },
            isRelPurchaseChange(){
                // console.log(this.pzlist.length,'this.pzlist.length')
                if(this.pzlist.length>0){
                    this.$confirm(this.$t('purchaseOrder_switching_to_associated_procurement_will_clear_the_product_list_do_you_want_to_continue'),this.$t('tips_prompt'),{
                        confirmButtonText:this.$t('button_continue'),
                        cancelButtonText:this.$t('button_cancel'),
                        type:'warning'
                    }).then(async()=>{
                        if(this.formData.isRelPurchase==1){
                            this.getCompanyList(1);
                            this.i_issq='1'
                            this.ismoren=true
                        }else{
                            this.formData.relRecvCompany=''
                            this.ismoren=false
                            this.formData.i_source=0;
                            this.formData.i_consignorid=0;
                            this.formData.vc_consignorname='';
                        }
                        this.pzlist=[]
                        this.formData.pzlist=[]
                    }).catch(()=>{
                        let isRelPurchase=this.formData.isRelPurchase;
                        this.formData.isRelPurchase=isRelPurchase==1?0:1;
                        this.$message({
                            type:'info',
                            message:this.$t('state_cancelled')
                        })
                    })
                }else{
                    if(this.formData.isRelPurchase==1){
                        this.getCompanyList(1);
                        this.i_issq='1'
                        this.ismoren=true
                    }else{
                        this.formData.relRecvCompany=''
                        this.ismoren=false
                        this.formData.i_source=0;
                        this.formData.i_consignorid=0;
                        this.formData.vc_consignorname='';
                    }
                }
                this.visible=false;
                this.isbtn=false;
            },


            chooseper(e){
                let choo = this.ysper.filter((item,index)=>{
                    return item.i_id == e
                })
                //console.log("choo",choo);
                if(choo.length!=0){
                    this.formData.i_wluid=choo[0].i_id;
                    this.formData.vc_wluname=choo[0].vc_name;
                }else{
                    this.formData.i_wluid=0;
                    this.formData.vc_wluname="";
                }
            },

            chooseys(e){
                //console.log("e",e)
                this.formData.istran=e;
                if(e==1){
                    this.getTranUserlist();
                }
            },

            //获取运输专员
            async getTranUserlist(){
                let param={};
                let res=await API.getTranUserlist(param);
                if(res.code==1){
                    this.ysper=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },

            changehy(e){
                //console.log(e,"e")
                if (e==0) this.i_issq='0';
                if (e==1) this.i_issq='1';
                this.pzlist=[];

            },
            choosesendway(e){
                //console.log(e)
                //console.log(this.i_isframe)
                let obj=this.sendway.find(item=>item.i_sendway==e)
                this.formData.vc_sendway = obj.vc_sendway
                if(this.i_isframe==1){
                    this.disys=true;
                    if(e==0){
                    // if(e=='送货'){
                        this.formData.istran=0
                    }else{
                        this.formData.istran=1
                        this.getTranUserlist();
                    }
                }
            },
            chooseckaddr(e){
                let choo = this.ckaddrData.filter((item,index)=>{
                    return item.i_id == e
                })
                //console.log("choo",choo);
                if(choo.length!=0){
                    this.formData.vc_sendadd=choo[0].vc_sendaddr+"/"+choo[0].vc_lxr+"/"+choo[0].vc_tel;
                    this.formData.vc_sendadd_lxr=choo[0].vc_lxr;
                    this.formData.vc_sendadd_lxr_tel=choo[0].vc_tel;
                    this.sendaddall= this.formData.vc_sendadd;
                }else{

                    this.formData.vc_sendadd='';
                    this.formData.vc_sendadd_lxr='';
                    this.formData.vc_sendadd_lxr_tel='';
                    this.sendaddall='';
                }
                this.$nextTick(()=>{
                    this.$forceUpdate()
                })

            },
            chooseck(e){
                let choo = this.ckData.filter((item,index)=>{
                    return item.i_id == e
                })
                //console.log("choo",choo);
                if(choo.length!=0){
                    this.formData.i_ckid=e;
                    this.formData.vc_ckname=choo[0].vc_name;
                    this.sendaddall='';
                    this.formData.vc_sendadd='';
                    this.formData.vc_sendadd_lxr='';
                    this.formData.vc_sendadd_lxr_tel='';
                    this.getAddressList();
                    //判断是否运输的禁用
                    let isstore=choo[0].isstore;
                    //console.log("this.i_isforeign",this.i_isforeign)
                    //console.log("this.formData.istran",this.formData.istran)
                    if(this.i_isforeign==0&&this.istran==1){
                        //console.log("isstore",isstore)
                        if(isstore==0){
                            this.formData.istran=0;
                            this.disys=false;
                        }else if(isstore==1||2){
                            this.formData.istran=1;
                            this.disys=true;
                        }
                    }
                }else{
                    this.formData.i_ckid='';
                    this.formData.vc_ckname='';
                }

            },
            async getCompanyList(isInnerCompany=null){
                let param={
                    i_mid:this.mid,
                    i_type:'0,2',
                    isInnerCompany:isInnerCompany==1?1:null
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    if(this.formData.isRelPurchase==1){
                        this.jtgsList=res.data
                    }else{
                        this.dxglgsList=res.data;

                    }
                    // console.log(this.jgsData,"this.jgsData")
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //仓库列表
            async getWarehouseList(){

                let param={
                    page_size:1,
                    page_count:999,
                };
                let res=await API.getWarehouseList(param);
                if(res.code==1){
                    this.ckData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            //仓库地址列表
            async getAddressList(){
                let param={
                    i_khid:this.formData.i_ckid,
                    page_size:1,
                    page_count:999,
                    vc_type:5,
                };
                let res=await API.getAddressList(param);
                if(res.code==1){
                    for(let i=0;i<res.data.length;i++){
                        res.data[i].vc_all=res.data[i].vc_sendaddr+'/'+res.data[i].vc_lxr+'/'+res.data[i].vc_tel;
                    }
                    this.ckaddrData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },

            choosegk(e,type){
                //console.log("e",e,"type",type);
                if(type=="qs"){
                    this.formData.i_startport=e;
                    if(this.formData.i_startport==this.formData.i_endport){
                        //console.log("???")
                        this.$message.error(this.$t('purchaseOrder_the_starting_and_destination_ports_cannot_be_the_same_port'));
                        this.formData.i_startport=0;
                        this.formData.vc_startport="";
                        return ;
                    }else{
                        let choo = this.gkData.filter((item,index)=>{
                            return item.i_id == e
                        });
                        //console.log("choo",choo);
                        if(choo.length!=0){
                            this.formData.vc_startport=choo[0].vc_name;
                        }else{
                            this.formData.vc_startport="";
                            this.formData.i_startport=0;
                        }

                    }
                };
                if(type=="md"){
                    this.formData.i_endport=e;
                    if(this.formData.i_endport==this.formData.i_startport){
                        //console.log("???")
                        this.$message.error(this.$t('purchaseOrder_the_starting_and_destination_ports_cannot_be_the_same_port'));
                        this.formData.i_endport=0;
                        this.formData.vc_endport="";
                        return ;
                    }else{
                        let choo = this.gkData.filter((item,index)=>{
                            return item.i_id == e
                        });
                        //console.log("choo",choo);
                        if(choo.length!=0){
                            this.formData.vc_endport=choo[0].vc_name;
                        }else{
                            this.formData.vc_endport='';
                            this.formData.i_endport=0;
                        }

                    }
                };
                if(type=="glsh"){
                    // console.log(this.formData.relRecvCompany,e,'------')
                    if(e == this.formData.i_gsid){
                        this.$message.error(this.$t('purchaseOrder_the_receiving_company_under_associated_procurement_cannot_be_the_ordering_company'))
                        this.formData.relRecvCompany = this.relRecvCompany;
                        this.$forceUpdate()
                        return;
                    }
                    if(this.pzlist.length>0){
                        this.$confirm(this.$t('purchaseOrder_switching_to_associated_receipt_will_clear_the_product_list_do_you_want_to_continue'),this.$t('tips_prompt'),{
                            confirmButtonText:this.$t('button_continue'),
                            cancelButtonText:this.$t('button_cancel'),
                            type:'warning'
                        }).then(async()=>{

                            this.bmData=[];
                            this.ryData=[];
                            this.formData.i_directPurchase_deptid = 0;
                            this.formData.vc_directPurchase_deptname='';
                            this.formData.i_directPurchase_uid = 0;
                            this.formData.vc_directPurchase_uname='';
                            if(this.formData.relRecvCompany){
                                this.getGroupList()
                                if (this.visible==true){
                                    this.productDetails={
                                        i_htid:this.i_htid,
                                        relRecvCompany:this.formData.relRecvCompany,
                                    }

                                }
                            }
                            this.pzlist=[]
                            this.formData.pzlist=[]
                            this.relRecvCompany=this.formData.relRecvCompany
                            this.$forceUpdate()
                            // console.log(this.formData.relRecvCompany,this.relRecvCompany)
                        }).catch(()=>{

                            this.formData.relRecvCompany=this.relRecvCompany;
                            this.$message({
                                type:'info',
                                message:this.$t('state_cancelled')
                            })
                            this.relRecvCompany=this.formData.relRecvCompany

                        })

                    }else{
                        this.formData.relRecvCompany = e;
                        this.bmData=[];
                        this.ryData=[];
                        this.formData.i_directPurchase_deptid = 0;
                        this.formData.vc_directPurchase_deptname='';
                        this.formData.i_directPurchase_uid = 0;
                        this.formData.vc_directPurchase_uname='';
                        if(this.formData.relRecvCompany){
                            this.getGroupList()
                            if (this.visible==true){
                                this.productDetails={
                                    i_htid:this.i_htid,
                                    relRecvCompany:this.formData.relRecvCompany,
                                }

                            }
                        }
                        this.relRecvCompany=this.formData.relRecvCompany
                    }
                };
                if(type=="bm"){
                    this.formData.i_directPurchase_deptid = e;
                    let choo = this.bmData.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_directPurchase_deptname=choo[0].vc_name;
                    } else {
                        this.formData.vc_directPurchase_deptname=''
                    }
                    this.ryData=[];
                    this.formData.i_directPurchase_uid = 0;
                    this.formData.vc_directPurchase_uname='';
                    if(this.formData.i_directPurchase_deptid)this.getPersonList()
                };
                if(type=="ry"){
                    this.formData.i_directPurchase_uid = e;
                    let choo = this.ryData.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_directPurchase_uname=choo[0].vc_name;
                    } else {
                        this.formData.vc_directPurchase_uname=''
                    }
                };

            },
            //港口列表
            async getPortList(){
                let param={
                    vc_search:"",
                };
                let res=await API.getPortList(param);
                if(res.code==1){
                    this.gkData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            choosekz(e){
                //console.log("e11111111111",e)
                let choo = this.kzData.filter((item,index)=>{
                    return item.i_id == e
                })
                //console.log("choo",choo);
                if(choo.length!=0){
                    this.formData.i_kzs=choo[0].i_id;
                    this.formData.vc_kzkhname=choo[0].vc_name;
                    this.formData.f_bzj=choo[0].f_bzj;
                }else{
                    this.formData.i_kzs="";
                    this.formData.vc_kzkhname="";
                    this.formData.f_bzj=0;
                }

            },
            //开证商列表
            async getLssuerList(){
                let param={
                    vc_search:"",
                };
                let res=await API.getLssuerList(param);
                if(res.code==1){
                    this.kzData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            //获取详情
            async getPurchaseOrderDetail(){
                let param={
                    i_id:this.i_id,
                };
                let res=await API.getPurchaseOrderDetail(param);
                if(res.code==1){
                    this.formData=res.data;
                    this.pzlist=res.data.pzlist;
                    this.getAddressList();
                    this.i_kpnumtype=res.data.i_kpnumtype.toString();
                    this.i_issq=res.data.i_issq.toString();
                    this.i_isforeign=res.data.i_isforeign;
                    //console.log("this.i_issq",this.i_issq);
                    //this.startaddall=res.data.vc_start_add+'/'+res.data.vc_start_lxr+'/'+res.data.vc_start_lxr_tel;
                    this.sendaddall=res.data.vc_sendadd+'/'+res.data.vc_sendadd_lxr+'/'+res.data.vc_sendadd_lxr_tel;
                    if(res.data.istran==1){
                        this.getTranUserlist();
                    }
                    //验证
                    this.i_id=res.data.i_id;
                    this.busType=res.data.busType;
                    this.dt_createtime=res.data.dt_createtime;
                    this.uid=res.data.uid;
                    this.table=res.data.table;
                    this.validateCode=res.data.validateCode;
                    this.validateKeynames=res.data.validateKeynames;
                    //更新倒计时
                    //let times ='2025-02-20 17:10:11';
                    let times =res.data.dt_expiretime;
                    times = (new Date(times)).getTime(); //得到时间戳
                    this.endTimestamp=times;
                    this.formData.vc_sendwayshow=this.sendway.find(s=>this.formData.vc_sendway==s.vc_sendway).vc_sendwayshow;

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            handleCountdownEnd() {
                //console.log('倒计时结束')
                this.endTimestamp=null;
            },

            /****************************************/
           /* async getPickingListSc(){
                let param={
                    i_mid:this.mid,
                    i_pid:this.i_pid,
                };
                let res=await API.getPickingListSc(param);
                if(res.code==1){
                    let data=res.data;
                    this.formRules={};$
                    this.formData={
                        gsname:data.vc_outgsname,
                        bmname:data.outcjname,
                        sqName:data.vc_squname,
                        ckname:data.vc_outckname,
                        num:data.i_id,
                        vc_note:data.vc_note,
                        vc_lruname:data.vc_lruname,
                        date:data.dt_createtime,
                        tableData:data.details,
                    };
                    // this.state=data.i_state;
                    this.tableData=data.details;
                    this.gsid=data.i_outgsid;
                    this.gid=data.i_cjid;
                    this.squid=data.i_squid;
                    this.sqName=data.vc_squname;
                    this.i_lruid=data.i_lruid;
                    this.i_lruname=data.i_lruname;
                    this.ckid=data.i_outckid;
                    this.productDetails.gsid=data.i_gsid;
                    this.productDetails.i_mid=this.mid;
                    this.productDetails.ckid=data.i_ckid;
                    this.productDetails.gsid_out=data.i_gsid_out;
                    this.productDetails.i_pzid=data.i_pzid;
                    this.productDetails.i_type=data.i_type;
                    this.productDetails.selected=[];
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },*/
            numinput(e,value,index){
                //console.log("pz",this.pzlist)
                //console.log("value",value,"e",e,"index",index)
                if(Number(e)<=0){this.$message.warning(this.$t('purchaseOrder_the_number_of_orders_cannot_be_less_than_or_equal_to'));return;}
                if (e> this.pzlist[index].f_num_ky) {

                    this.$confirm(this.$t('purchaseOrder_do_you_want_to_continue_if_the_number_of_orders_issued_exceeds_the_available_quantity_in_the_contract'), this.$t('tips_prompt'), {
                        confirmButtonText: this.$t('button_sure'),
                        cancelButtonText: this.$t('button_cancel'),
                        type: 'warning'
                    }).then(() => {
                        this.pzlist[index].f_num=e;
                        this.pzlist[index].f_je=(e*this.pzlist[index].f_price).toFixed(2);
                        //this.saveForm();
                    }).catch(() => {
                        this.pzlist[index].f_num=this.pzlist[index].f_num_ky ;
                        this.pzlist[index].f_je=(this.pzlist[index].f_num*this.pzlist[index].f_price).toFixed(2);

                    });
                    /*return;
                    //console.log("e",e )
                    //console.log("this.pzlist[index].f_num_ky",this.pzlist[index].f_num_ky )
                    this.$message.error("开单数量应小于合同可用量！");
                    this.pzlist[index].f_num=0 ;
                    this.pzlist[index].f_je=(this.pzlist[index].f_num*this.pzlist[index].f_price).toFixed(2);*/

                }else{
                    this.pzlist[index].f_num=e;
                    this.pzlist[index].f_je=(e*this.pzlist[index].f_price).toFixed(2);
                }
            },
            popShow(){
                // console.log(this.formData.relRecvCompany,'this.relRecvCompany')
                this.productDetails={
                    i_htid:this.i_htid,
                    relRecvCompany:this.formData.relRecvCompany,
                    i_source:this.formData.i_source,
                }
                this.visible=true;
                if (this.visible==true){
                    this.isbtn=true
                }
                //console.log(this.visible)
                /*if (this.formData.gsname==''||this.formData.ckname==''){
                    this.$message.error("请选择公司或仓库")
                    return
                }else if(this.formData.gsname!=''&&this.formData.ckname!=''){
                    this.visible=true;
                }
                if (this.visible==true){
                    this.isbtn=true
                }*/
            },
            closePop(){
                this.visible=false;
                this.isbtn=false;
            },
            //产品列表
            transValue(value){
                /*let arr=[];
                if ( this.formData.tableData.length>0){

                }else {
                     arr=[...value];
                }*/
                let arr=[...this.pzlist,...value];
                // console.log(value,"------------")

                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    //hash[next.vc_unique] ? '' : hash[next.vc_unique] = true && item.push(next);
                    hash[next.i_pzid+'/'+next.vc_pzname+'/'+next.f_num_ky] ? '' : hash[next.i_pzid+'/'+next.vc_pzname+'/'+next.f_num_ky] = true && item.push(next);
                    return item
                }, []);
                //console.log("arr?????",arr)
                for(let i=0;i<arr.length;i++){
                    arr[i].f_num=arr[i].f_num_ky;
                    arr[i].f_je=(arr[i].f_num*arr[i].f_price).toFixed(2);
                }
                this.formData.pzlist=arr;
                this.pzlist=arr;
                this.productDetails.selected=this.pzlist;
                let price0=this.pzlist.filter(pz=>pz.relPrice==0||pz.relPrice==undefined);
                if(price0.length>0&&this.formData.isRelPurchase==1){
                    this.$message.warning(this.$t('purchaseOrder_the_unit_price_of_the_receiving_company_is_please_list_it_first'))
                }

                /*this.formData.tableData=arr;
                this.tableData=arr;
                this.productDetails.selected=this.tableData;*/
                //console.log("**arr**",newArr3)
            },
            deleteRow(value,index){
                this.pzlist.splice(index,1);
                /*this.index=index;
                this.tableData.splice(this.index,1);
                // console.log(value,"-----")*/
            },
            //提交审批
            toApprove(){
            },
            terminate(){
                if(this.formData.i_over==1){this.$message.error(this.$t('purchaseOrder_this_order_cannot_be_terminated'));return ;}
                this.$confirm(this.$t('purchaseOrder_please_check_the_execution_status_before_terminating_and_confirm_whether_to_terminate'), this.$t('tips_prompt'), {
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.toterminate();
                }).catch(() => {

                });
            },
            async toterminate(){
                let param={
                    i_id:this.i_id,
                };
                let res=await API.terminatePurchaseOrder(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.$emit('getPurchaseOrderList',this.pageSize);
                    this.cancel();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            cancel(){
                //console.log(this.pageSize,"------")
                //this.formData={};
                this.visible=false;
                this.$emit('close',"ht");

                //this.$emit('getPickingReqList')
            },
            //保存
            async saveForm(){
                //console.log("this.formData",this.formData);
                //console.log("this.pzlist",this.pzlist);
                if(this.formData.isRelPurchase==1&&this.formData.i_gsid!==this.formData.relRecvCompany&&(this.formData.i_directPurchase_deptid==0||this.formData.i_directPurchase_uid==0)){
                    this.$message.error(this.$t('purchaseOrder_please_select_the_direct_procurement_department_and_direct_procurement_business'));
                    return ;
                }
                if (this.pzlist.length==0){
                    this.$message.error(this.$t('purchaseOrder_please_select_the_procurement_variety'));
                    return ;
                }
                let price0=this.pzlist.filter(pz=>pz.relPrice==0||pz.relPrice==undefined);
                if(price0.length>0&&this.formData.isRelPurchase==1){
                    this.$message.warning(this.$t('purchaseOrder_the_unit_price_of_the_receiving_company_is_please_list_it_first'))
                    return
                }
                let kong = this.pzlist.some((item)=>{
                    return item.f_num<=0
                });
                //console.log("kong",kong);
                if(kong){
                    this.$message.error(this.$t('purchaseOrder_the_number_of_orders_cannot_be_0'));
                    return ;
                }
                if(this.formData.vc_sendway==''){
                    this.$message.error(this.$t('purchaseOrder_the_vc_sendway_cannot_be_empty'));
                    return ;
                }
                if(this.i_issq==1){
                    if (this.formData.vc_ckname==''){
                        this.$message.error(this.$t('purchaseOrder_the_warehouse_cannot_be_empty'));
                        return ;
                    }
                    if (this.formData.vc_sendadd==''){
                        this.$message.error(this.$t('purchaseOrder_the_warehouse_address_cannot_be_empty'));
                        return ;
                    }
                    if(this.formData.istran==1){
                        if(!this.formData.vc_wluname){
                            this.$message.error(this.$t('purchaseOrder_please_select_a_logistics_specialist'));
                            return ;
                        }
                    }else{
                        this.formData.vc_wluname='';
                        this.formData.i_wluid=0;
                    }
                    if(this.formData.dt_yjdhtime==''||!this.formData.dt_yjdhtime){
                        this.$message.error(this.$t('purchaseOrder_please_select_the_expected_delivery_time'));
                        return ;
                    }

                    /*let kong = this.pzlist.some((item)=>{
                        return item.vc_pcno==""||!item.vc_pcno
                    });
                    console.log("kong",kong);
                    if(kong){
                        this.$message.error("请输入入库批次号！");
                        return ;
                    }*/

                }
                if(this.formData.can_add_lc==1){
                    if (this.formData.dt_kztime==''){
                        this.$message.error(this.$t('purchaseOrder_please_select_issuing_date'));
                        return ;
                    }
                    if (this.formData.i_lcday==''){
                        this.$message.error(this.$t('purchaseOrder_please_select_lct_days'));
                        return ;
                    }
                    if(this.formData.vc_xyno==''){
                        this.$message.error(this.$t('purchaseOrder_please_select_lc_number'));
                        return ;
                    }

                }
                //return;
                this.disabled=true;
                this.loading=true;
                let param={
                    htid:this.i_htid,
                    i_id:this.formData.i_id,
                    i_type:this.formData.i_type,
                    vc_type:this.formData.vc_type,
                    vc_no: this.formData.vc_no,
                    vc_fno: this.formData.vc_fno,
                    i_gsid:this.formData.i_gsid,
                    vc_company: this.formData.vc_company,
                    i_gid:this.formData.i_gid,
                    vc_bmname:this.formData.vc_bmname,
                    i_kduid:this.formData.i_kduid,
                    vc_kduname:this.formData.vc_kduname,
                    i_gykhid:this.formData.i_gykhid,
                    vc_gysname: this.formData.vc_gysname,
                    i_payid: this.formData.i_payid,
                    vc_paytype: this.formData.vc_paytype,
                    i_payway: this.formData.i_payway,
                    vc_payway: this.formData.vc_payway,
                    i_kpnumtype:this.i_kpnumtype,
                    vc_paynote: this.formData.vc_paynote,
                    i_bzid:this.formData.i_bzid,
                    vc_bzname: this.formData.vc_bzname,
                    f_rate: this.formData.f_rate,
                    i_ckid:this.formData.i_ckid,
                    vc_ckname:this.formData.vc_ckname,
                    vc_sendadd: this.formData.vc_sendadd,
                    vc_sendadd_lxr:this.formData.vc_sendadd_lxr,
                    vc_sendadd_lxr_tel: this.formData.vc_sendadd_lxr_tel,
                    vc_start_add:this.formData.vc_start_add,
                    vc_start_lxr: this.formData.vc_start_lxr,
                    vc_start_lxr_tel:this.formData.vc_start_lxr_tel,
                    vc_reviewnote:this.formData.vc_reviewnote,
                    vc_lruname:this.formData.vc_lruname,
                    dt_createtime: this.formData.dt_createtime,
                    dt_yjdhtime: this.formData.dt_yjdhtime,
                    uid:this.uid,
                    table:this.table,
                    busType:this.busType,
                    validateCode: this.validateCode,
                    validateKeynames:this.validateKeynames,
                    vc_tdcode:this.formData.vc_tdcode,
                    dt_tdtime: this.formData.dt_tdtime,
                    i_startport: this.formData.i_startport,
                    vc_startport:this.formData.vc_startport,
                    i_endport:this.formData.i_endport,
                    vc_endport: this.formData.vc_endport,
                    //i_kzkhid:this.formData.i_kzkhid,
                    i_kzs:this.formData.i_kzs,
                    vc_kzkhname:this.formData.vc_kzkhname,
                    f_bzj:this.formData.f_bzj,
                    dt_kztime: this.formData.dt_kztime,
                    i_lcday:this.formData.i_lcday,
                    vc_xyno:this.formData.vc_xyno,
                    vc_yffd:this.formData.vc_yffd,
                    vc_sendway:this.formData.vc_sendway,
                    i_issq:this.i_issq,
                    i_isframe:this.formData.i_isframe,
                    i_isforeign:this.i_isforeign,
                    //化验
                    i_ischeck:this.i_ischeck,
                    pzlist:this.pzlist,
                    //运输和物流专员
                    istran:this.formData.istran,
                    i_wluid:this.formData.i_wluid,
                    vc_wluname:this.formData.vc_wluname,
                    i_isdirexport:this.formData.i_isdirexport,
                    i_dirgsid:this.formData.i_dirgsid,
                    //直发采购
                    isRelPurchase:this.formData.isRelPurchase,
                    relRecvCompany:this.formData.relRecvCompany,
                    i_directPurchase_deptid:this.formData.i_directPurchase_deptid,
                    //vc_directPurchase_deptname:this.formData.vc_directPurchase_deptname,//后端不用传
                    i_directPurchase_uid:this.formData.i_directPurchase_uid,
                    vc_directPurchase_uname:this.formData.vc_directPurchase_uname,
                    i_xtype:this.formData.i_xtype,
                    i_source:this.formData.i_source,
                    i_consignorid:this.formData.i_consignorid,
                    vc_consignorname:this.formData.vc_consignorname,
                    can_add_lc:this.formData.can_add_lc,
                };
                //console.log("param",param)
                //return;
                let res=await API.saveOrder(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.$emit('getPurchaseOrderList',this.pageSize);
                    this.cancel();
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else if (res.code == -11) {
                    //console.log('12345')
                    //this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message+this.$t('purchaseOrder_automatic_submission_for_approval_failed_please_return_to_the_application_list_and_manually_submit_for_approval'));
                }else if (res.code == 0) {
                    // console.log('12345')
                    //this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.dt_createtime=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
                if (row.relPrice==0||row.relPrice==undefined) {
                    return 'danger-row';
                }
            },
        }
    }
</script>

<style  lang="scss" scoped>
    .fontW500{
        font-weight: 500;
    }
    .marT10{
        margin-top: 10px;
    }
    .point{
        font-size: 10px;
        color: #fa5050;
        height: 10px;
        line-height: 10px;
    }
    /deep/.el-input__suffix{
        right: 12px;
    }
    /deep/.nodata .el-input__inner{
        padding: 0 9px;
    }
    .wid100{
        width: 100%;
    }

    .mar3{
        margin:3px 0px;
    }
    .moren .el-form-item__label{
        width:150px !important;
    }
    .inputw{
        //width:calc(100% - 90px);
    }
    .wid50{
        width: calc(50% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    .wid100_bz{
        width: calc(100% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    .mart20{
        margin-top: 20px;
    }
    .borb{
        //border-bottom: 1px solid #efefef;
        //margin-top: 1px;
    }
    .fr{
        float: right;
    }
    .wid60{
        width: 60%;
    }
    .width100_f{
        width: calc(100% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }

    .wid66{
        width: calc(66% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }

    .form-title{
        width: calc(33% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
        display: flex;
    }
    .flex{
        display: flex;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }

    .num .el-form-item__label {
        color: #b3d268;
        font-size: 16px;
        font-style: italic;
    }
    .num .el-form-item__content {
        width: 150px;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .tableForm-item{
        margin: 0;
        width: 100%;
        /deep/{
            .el-form-item__content{
                width: 100%;
                margin-left: 0 !important;
            }
        }
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }
    /deep/.guding{
        /*.el-form-item__label{*/
        /*    min-width: 85px !important;*/
        /*    margin-right: 3px !important;*/
        /*}*/
    }

    /deep/.table {
        .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
            margin-bottom: 0px;
        }

        .el-form-item__label{
            text-align: left;
            color: #808080;
            min-width: 94px;
            margin-right: 9px;
            padding: 0px !important;
            font-size: 14px !important;
        }

        .el-input--mini .el-input__inner{
            height: 24px;
            line-height: 24px;
        }
        .el-form-item__content{
            width: 100%;
        }
        .el-radio{
            margin-right: 15px;
        }
    }


</style>
